/* eslint-disable no-useless-escape */

/* eslint-disable no-unused-vars */
const config = {
    conditions: {
        speed: {
            unit: 'км/ч',
            default: -1.0,
        },
        course: {
            unit: '°',
            default: -1.0,
        },
        height: {
            unit: 'м',
            default: -10000,
        },
        total_mileage: {
            unit: 'км',
            default: -1,
        },
        env_temperature: {
            unit: '℃',
            default: -100,
        },
        terminal_temperature: {
            unit: '℃',
            default: -100,
        },
        acc_voltage: {
            unit: 'V',
            default: -1.0,
        },
        voltage: {
            unit: 'V',
            default: -1.0,
        },
        can_speed: {
            unit: 'км/ч',
            default: -1,
        },
        engine_coolant_temperature: {
            unit: '℃',
            default: -1,
        },
        engine_speed: {
            unit: 'об/мин',
            default: -1,
        },
        gas_pedal: {
            unit: '%',
            default: -1,
        },
        engine_load: {
            unit: '%',
            default: -1,
        },
        fuel_level: {
            unit: 'л',
            default: -1.0,
        },
        total_fuel_consumption: {
            unit: 'л',
            default: -1.0,
        },
        gearoil_temperature: {
            unit: '℃',
            default: -100,
        },
        signal_strength: {
            unit: '',
            default: -1,
        },
        alarm_btn: {
            unit: '',
            default: -1,
        },
        sensor_lost: {
            unit: '',
            default: -1,
        },
        sensor_count: {
            unit: '',
            default: -1,
        },
        engine_status: {
            unit: '',
            default: -1,
        },
        acc_status: {
            unit: '',
            default: -1,
        },
        is_parked: {
            unit: '',
            default: -1,
        },
        parking_overtime: {
            unit: '',
            default: -1,
        },
        parking_time: {
            unit: 'мин.',
            default: -1,
        },
        geodata: {
            unit: '',
            default: 'NA',
        },
        geofence_id: {
            unit: '',
            default: 0,
        },
        dut: {
            unit: '',
            default: -1,
        },
        dun: {
            unit: '°',
            default: -1,
        },
        dun_cover: {
            unit: '°',
            default: -1,
        },
        dun_cover_2: {
            unit: '°',
            default: -1,
        },
        guard_out: {
            unit: '',
            default: -1,
        },
        guard_status: {
            unit: '',
            default: -1,
        },
        ibutton1: {
            unit: '',
            default: '00000000',
        },
        axle1_load: {
            unit: 'т',
            default: 0,
        },
        axle2_load: {
            unit: 'тонн',
            default: 0,
        },
        sensor_sn: {
            unit: '',
            default: 0,
        },
        sats: {
            unit: '',
            default: -1,
        },
        device_ext_status: {
            unit: '',
            default: -1,
        },
        hdop: {
            unit: '',
            default: -1,
        },
        uza_status: {
            unit: '',
            default: -1,
        },
        dps: {
            unit: '',
            default: -1,
        },
    },
    compareEvents: {
        geofence_id: [
            {
                name: 'geofence',
                key: 'geofence:in',
                message: 'Въезд в геозону',
                analysis: false,
                compare: [
                    function (a) {
                        return a !== 0;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
            {
                name: 'geofence',
                key: 'geofence:out',
                message: 'Покинул геозону',
                analysis: false,
                compare: [
                    function (a) {
                        return a === 0;
                    },
                    function (a, b) {
                        return b !== 0;
                    },
                ],
            },
        ],
        bt_id_1: [
            {
                name: 'geofence',
                key: 'bt:in',
                message: 'Получена BT-метка',
                analysis: false,
                compare: [
                    function (a) {
                        return !['00000000', 'NANANANA'].includes(a);
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        engine_status: [
            {
                name: 'engine',
                key: 'engine:off',
                message: 'Двигатель заглушен',
                analysis: false,
                compare: [
                    function (a) {
                        return [1].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
            {
                name: 'engine',
                key: 'engine:on',
                message: 'Двигатель заведен',
                analysis: false,
                compare: [
                    function (a) {
                        return [2].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        acc_status: [
            {
                name: 'engine',
                key: 'acc:off',
                message: 'Зажигание выключено',
                analysis: false,
                compare: [
                    function (a) {
                        return [0].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
            {
                name: 'engine',
                key: 'acc:on',
                message: 'Зажигание включено',
                analysis: false,
                compare: [
                    function (a) {
                        return [1].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        is_parked: [
            {
                name: 'speed',
                key: 'parking:start',
                message: 'Начало парковки',
                analysis: true,
                compare: [
                    function (a) {
                        return [1].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
            {
                name: 'speed',
                key: 'parking:off',
                message: 'Начало движения',
                analysis: true,
                compare: [
                    function (a) {
                        return [0].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        parking_overtime: [
            {
                name: 'speed',
                key: 'parking:overtime',
                message: 'Время парковки превышено',
                analysis: false,
                compare: [
                    function (a) {
                        return [1].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        parking_time: [
            {
                name: 'speed',
                key: 'parking:pause',
                message: 'Эталоны ДУН обновлены при остановке',
                analysis: false,
                compare: [
                    function (a) {
                        return a === 5;
                    },
                    function (a, b) {
                        return true;
                    },
                ],
            },
            {
                name: 'speed',
                key: 'parking:delay',
                message: 'Эталон уровней топлива записан',
                analysis: false,
                compare: [
                    function (a) {
                        return a === 30;
                    },
                    function (a, b) {
                        return true;
                    },
                ],
            },
            {
                name: 'speed',
                key: 'parking:stop',
                message: 'Машина на длительной парковке',
                analysis: false,
                compare: [
                    function (a) {
                        return a > 21600;
                    },
                    function (a, b) {
                        return b <= 21600;
                    },
                ],
            },
        ],
        can_speed: [
            {
                name: 'speed',
                key: 'speed:limit',
                message: 'Превышена скорость движения',
                analysis: false,
                compare: [
                    function (a) {
                        return a > 90 && a < 255;
                    },
                    function (a, b) {
                        return b <= 90;
                    },
                ],
            },
        ],
        alarm_btn: [
            {
                name: 'reason',
                key: 'alarm_btn:off',
                message: 'Тревожная кнопка отпущена',
                analysis: false,
                compare: [
                    function (a) {
                        return [0].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
            {
                name: 'reason',
                key: 'alarm_btn:on',
                message: 'Нажата кнопка тревоги',
                analysis: false,
                compare: [
                    function (a) {
                        return [1].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return true;
                    },
                ],
            },
        ],
        sensor_lost: [
            {
                name: 'reason',
                key: 'sensor:lost',
                message: 'Потерян датчик',
                analysis: false,
                compare: [
                    function (a) {
                        return [1].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return true;
                    },
                ],
            },
            {
                name: 'reason',
                key: 'sensor:restored',
                message: 'Конфигурация датчиков обновлена',
                analysis: false,
                compare: [
                    function (a) {
                        return [0].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b && [1].indexOf(b) !== -1;
                    },
                ],
            },
            {
                name: 'reason',
                key: 'voltage:low',
                message: 'Низкое напряжение сети',
                analysis: false,
                compare: [
                    function (a) {
                        return [2].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
            {
                name: 'reason',
                key: 'voltage:restored',
                message: 'Напряжение сети восстановлено',
                analysis: false,
                compare: [
                    function (a) {
                        return [0].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return a !== b && [2].indexOf(b) !== -1;
                    },
                ],
            },
            {
                name: 'reason',
                key: 'voltage:high',
                message: 'Высокое напряжение сети',
                analysis: false,
                compare: [
                    function (a) {
                        return [3].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return true;
                    },
                ],
            },
            {
                name: 'reason',
                key: 'sensor:missing',
                message: 'Отсутствует датчик',
                analysis: false,
                compare: [
                    function (a) {
                        return [9].indexOf(a) !== -1;
                    },
                    function (a, b) {
                        return true;
                    },
                ],
            },
        ],
        event_id: [
            {
                name: 'reason',
                key: 'event_id:1',
                message: 'Одновременный слив',
                analysis: false,
                compare: [
                    function (a) {
                        return a === 1;
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        dun_cover: [
            {
                name: 'alert',
                key: 'dun_cover:on',
                message: 'Крышка слива открыта',
                analysis: true,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun_cover:off',
                message: 'Крышка слива закрыта',
                analysis: true,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        dun_cover_2: [
            {
                name: 'alert',
                key: 'dun_cover_2:on',
                message: 'Крышка слива 2 открыта',
                analysis: true,
                compare: [
                    function (a) {
                        return a >= 30 && a !== 65534;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun_cover_2:off',
                message: 'Крышка слива 2 закрыта',
                analysis: true,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return (b >= 30) & (b !== 65534);
                    },
                ],
            },
        ],
        dun1: [
            {
                name: 'alert',
                key: 'dun1:on',
                message: 'Крышка 1 открыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun1:off',
                message: 'Крышка 1 закрыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        dun2: [
            {
                name: 'alert',
                key: 'dun2:on',
                message: 'Крышка 2 открыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun2:off',
                message: 'Крышка 2 закрыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        dun3: [
            {
                name: 'alert',
                key: 'dun3:on',
                message: 'Крышка 3 открыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun3:off',
                message: 'Крышка 3 закрыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        dun4: [
            {
                name: 'alert',
                key: 'dun4:on',
                message: 'Крышка 4 открыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun4:off',
                message: 'Крышка 4 закрыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        dun5: [
            {
                name: 'alert',
                key: 'dun5:on',
                message: 'Крышка 5 открыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun5:off',
                message: 'Крышка 5 закрыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        dun6: [
            {
                name: 'alert',
                key: 'dun6:on',
                message: 'Крышка 6 открыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a >= 30;
                    },
                    function (a, b) {
                        return b < 30;
                    },
                ],
            },
            {
                name: 'alert',
                key: 'dun6:off',
                message: 'Крышка 6 закрыта',
                analysis: false,
                compare: [
                    function (a) {
                        return a < 30;
                    },
                    function (a, b) {
                        return b >= 30;
                    },
                ],
            },
        ],
        guard_status: [
            {
                name: 'alert',
                key: 'guard_status1',
                message: 'Сработка СК1',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[8] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[8] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status2',
                message: 'Сработка СК2',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[7] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[7] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status3',
                message: 'Сработка СК3',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[6] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[6] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status4',
                message: 'Сработка СК4',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[5] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[5] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status5',
                message: 'Сработка СК5',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[4] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[4] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status6',
                message: 'Сработка СК6',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[3] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[3] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status7:on',
                message: 'Сработка СК7',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[2] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[2] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status8:on',
                message: 'Тревога',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status8:off',
                message: 'Тревога отключена',
                analysis: true,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '0';
                    },
                ],
            },
            {
                name: 'alert',
                key: 'guard_status9:off',
                message: 'Нарушена связь с прицепом',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[0] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[0] !== '1';
                    },
                ],
            },
        ],
        guard_out: [
            {
                name: 'guard',
                key: 'guard_out1:on',
                message: 'Охрана СК1 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[8] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[8] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out2:on',
                message: 'Охрана СК2 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[7] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[7] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out3:on',
                message: 'Охрана СК3 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[6] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[6] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out4:on',
                message: 'Охрана СК4 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[5] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[5] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out5:on',
                message: 'Охрана СК5 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[4] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[4] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out6:on',
                message: 'Охрана СК6 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[3] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[3] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out7:on',
                message: 'Охрана СК7 включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[2] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[2] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out1:off',
                message: 'Охрана СК1 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[8] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[8] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out2:off',
                message: 'Охрана СК2 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[7] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[7] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out3:off',
                message: 'Охрана СК3 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[6] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[6] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out4:off',
                message: 'Охрана СК4 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[5] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[5] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out5:off',
                message: 'Охрана СК5 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[4] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[4] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out6:off',
                message: 'Охрана СК6 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[3] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[3] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out7:off',
                message: 'Охрана СК7 выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (a >>> 0).toString(2).padStart(9, '0')[2] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1' && (b >>> 0).toString(2).padStart(9, '0')[2] !== '0';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out8:on',
                message: 'Охрана включена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '0';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '1';
                    },
                ],
            },
            {
                name: 'guard',
                key: 'guard_out8:off',
                message: 'Охрана выключена',
                analysis: false,
                compare: [
                    function (a) {
                        return (a >>> 0).toString(2).padStart(9, '0')[1] !== '1';
                    },
                    function (a, b) {
                        return (b >>> 0).toString(2).padStart(9, '0')[1] !== '0';
                    },
                ],
            },
        ],
        ibutton1: [
            {
                name: 'guard',
                key: 'key:on',
                message: 'Приложен ключ',
                analysis: false,
                compare: [
                    function (a) {
                        return a !== '00000000';
                    },
                    function (a, b) {
                        return a !== b;
                    },
                ],
            },
        ],
        command: [
            {
                name: 'command',
                key: 'GC 1',
                message: 'Включить реле секции 1',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 2',
                message: 'Включить реле секции 2',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 3',
                message: 'Включить реле секции 3',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 4',
                message: 'Включить реле секции 4',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 5',
                message: 'Включить реле секции 5',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 6',
                message: 'Включить реле секции 6',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 7',
                message: 'Включить замок дверцы слива',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 8',
                message: 'Включить режим общей охраны',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 9',
                message: 'Включить режим игнорирования датчиков',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 10',
                message: 'Отключить тревогу',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 11',
                message: 'Отключить реле секции 1',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 12',
                message: 'Отключить реле секции 2',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 13',
                message: 'Отключить реле секции 3',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 14',
                message: 'Отключить реле секции 4',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 15',
                message: 'Отключить реле секции 5',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 16',
                message: 'Отключить реле секции 6',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 17',
                message: 'Отключить замка дверцы слива',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 18',
                message: 'Отключить режим общей охраны',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 18,9999',
                message: 'Отключить режим охраны для секций',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 19',
                message: 'Отключить режим игнорирования датчиков',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 20',
                message: 'Постановка на охрану при покидании налива',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 26',
                message: 'Постановка на охрану и отключение тревоги',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 27',
                message: 'Отключить охрану и тревогу',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 27,9999',
                message: 'Отключить тревогу и режим охраны для секций',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 30',
                message: 'Открыть УЗА реле (пневмоклапан)',
                analysis: false,
            },
            {
                name: 'command',
                key: 'GC 31',
                message: 'Закрыть УЗА реле (пневмоклапан)',
                analysis: false,
            },
            {
                name: 'command',
                key: 'reset',
                message: 'Перезагрузить терминал',
                analysis: false,
            },
        ],
        other: [
            {
                name: 'other',
                key: 'other:message',
                message: 'Событие для отображения трека',
                analysis: false,
            },
        ],
    },
    driverListOptions: {
        itemHeight: 36,
        itemBuffered: 30,
    },
    issueColumns: [
        { name: 'title', label: 'Тема', width: 152, order: 'ASC', permissions: ['*'] },
        { name: 'created_at', label: 'Дата создания', width: 118, order: 'DESC', format: (value) => moment(value).format('DD.MM.YYYY HH:mm'), permissions: ['*'] },
        { name: 'transport_number', label: 'Госномер ТС', width: 101, order: 'ASC', permissions: ['*'] },
        { name: 'status', label: 'Статус', width: 88, order: 'ASC', permissions: ['*'] },
    ],
    issueListOptions: {
        itemHeight: 30,
        itemBuffered: 30,
        itemStickyHeight: 30,
    },
    inspectionColumns: [
        { name: 'created_at', label: 'Время проведения', width: 150, order: 'DESC', format: (value) => moment(value).format('DD.MM.YYYY HH:mm:ss'), permissions: ['checklist_read'] },
        { name: 'download', label: 'Скачать', width: 44, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'number', label: 'Госномер', width: 80, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'trailer', label: 'Прицеп', width: 80, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'group_name', label: 'Автоколонна', width: 100, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'employee', label: 'Сотрудник', width: 110, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'status', label: 'Статус', width: 73, order: 'ASC', permissions: ['checklist_read'] },
    ],
    /** Таблица осмотров для Voykan: бригада, цех (группа ТС), направление (автоколонны шаблона). */
    inspectionColumnsVoykan: [
        { name: 'created_at', label: 'Время проведения', width: 150, order: 'DESC', format: (value) => moment(value).format('DD.MM.YYYY HH:mm:ss'), permissions: ['checklist_read'] },
        { name: 'download', label: 'Скачать', width: 44, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'number', label: 'Бригада', width: 80, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'transport_group_name', label: 'Цех', width: 60, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'autocolon_name', label: 'Направление', width: 140, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'employee', label: 'Сотрудник', width: 110, order: 'ASC', permissions: ['checklist_read'] },
        { name: 'status', label: 'Статус', width: 73, order: 'ASC', permissions: ['checklist_read'] },
    ],
    inspectionStatuses: [
        { label: 'Выезд разрешен', value: 1 },
        { label: 'Выезд запрещен', value: 0 },
    ],
    /** Подписи статусов осмотра в фильтрах для Voykan (те же value 0/1). */
    inspectionStatusesVoykan: [
        { label: 'Хорошо', value: 1 },
        { label: 'Требует внимания', value: 0 },
    ],
    /** Сборка с CLIENT_UI=voykan — UI чеклистов под заказчика Voykan (бригады). */
    clientUi: process.env.CLIENT_UI === 'voykan' ? 'voykan' : 'default',
    checklistTemplateColumns: [
        { name: 'name', label: 'Название', width: 200, order: 'DESC' },
        { name: 'created_at', label: 'Создан', width: 140, order: 'DESC', format: (value) => (value ? moment(value).format('DD.MM.YYYY HH:mm:ss') : null), permissions: ['checklist_read'] },
        { name: 'updated_at', label: 'Изменен', width: 140, order: 'DESC', format: (value) => (value ? moment(value).format('DD.MM.YYYY HH:mm:ss') : null), permissions: ['checklist_read'] },
        { name: 'active', label: 'Статус', width: 90, order: 'DESC', format: (value) => (value ? 'Активен' : 'Не активен'), permissions: ['checklist_read'] },
    ],
    checklistTemplateHistoryColumns: [
        { name: 'key', label: 'Номер ревизии', width: 150, permissions: ['checklist_read'] },
        { name: 'created_at', label: 'Дата изменения', width: 200, format: (value) => (value ? moment(value).format('DD.MM.YYYY HH:mm:ss') : null), permissions: ['checklist_read'] },
    ],
    defaultTrackerOptions: {
        parking_time: 600,
        sensor_lost_cycles_count: 12,
        number_m: 5,
        ignore_lost_cycles_count: 21,
        number_n: 30,
        speed_mode: 1,
        dut_guard_level: 300,
        auto_staging_guard_speed: 30,
        measurement_dut_level_number: 20,
        can_generation: 5,
    },
    userTabs: [
        { name: 'info', label: 'Информация' },
        { name: 'group', label: 'Группы транспорта' },
    ],
    transportTabs: [
        { name: 'info', label: 'Информация' },
        { name: 'parameters', label: 'Параметры СЭП' },
    ],
    userListOptions: {
        itemHeight: 36,
        itemBuffered: 30,
    },
    transportGroupTabs: [
        { name: 'info', label: 'Информация' },
        { name: 'list', label: 'Транспортные средства' },
    ],
    transportColumns: [
        { name: 'name', label: 'Название', width: 112, order: 'ASC' },
        { name: 'number', label: 'Госномер', width: 105, order: 'ASC' },
        { name: 'group_name', label: 'Группа', width: 120, order: 'ASC' },
        { name: 'volume', label: 'Бак', width: 50, order: 'ASC' },
        { name: 'imei', label: 'IMEI', width: 55, order: 'ASC', format: (value) => value?.substr(-4) },
    ],
    transportNumberOptions: [
        { code: 'ru', title: 'RU', placeholder: ['А000АА 77'], mask: ['A999AA 999'], formatChars: 'АВЕКМНОРСТУХ', pattern: [/^([АВЕКМНОРСТУХ]{1}[0-9]{3}[АВЕКМНОРСТУХ]{2}\s?[0-9]{2,3})?$/iu], checkPattern: [/^[ABCEHKMOPCTYX]{1}/] },
        {
            code: 'by',
            title: 'BY',
            placeholder: ['AX 0000-0', '0000 AX-0'],
            mask: ['AA 9999-9', '9999 AA-9'],
            formatChars: 'ABCEHKMOPCTYX',
            pattern: [/^[ABCEHKMOPCTYX]{2}\s?[0-9]{4}-?[0-9]{1,2}$/iu, /^[0-9]{4}\s?[ABCEHKMOPCTYX]{2}-?[0-9]{1,2}$/iu],
            checkPattern: [/^[ABCEHKMOPCTYX]{1}/, /^[0-9]{1}/],
        },
        { code: 'az', title: 'AZ', placeholder: ['00-AZ-000'], mask: ['99-AA-999'], formatChars: 'A-Z', pattern: [/^[0-9]{2}[-]?[A-Z]{2}[-]?[0-9]{3}$/iu], checkPattern: [/^[0-9]{1}/] },
    ],
    transportPhoneNumberOptions: [
        { code: 'ru', title: 'RU', placeholder: ['+7 XXX XXX-XXXX'], mask: ['+7 (000) 000-0000'], formatChars: '0-9', pattern: [/^((\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/im], checkPattern: [/^[0-9]{1}/] },
        { code: 'by', title: 'BY', placeholder: ['+375 XX XXX-XXXX'], mask: ['+375 (00) 000-0000'], formatChars: '0-9', pattern: [/^((\+375)[\- ]?)?(\(?\d{2}\)?[\- ]?)?[\d\- ]{7,10}/im], checkPattern: [/^[0-9]{1}/] },
        { code: 'az', title: 'AZ', placeholder: ['+994 XX XXX-XXXX'], mask: ['+994 (00) 000-0000'], formatChars: '0-9', pattern: [/^((\+994)[\- ]?)?(\(?\d{2}\)?[\- ]?)?[\d\- ]{7,10}/im], checkPattern: [/^[0-9]{1}/] },
    ],
    transportDeviceOptions: [
        { type: 1, title: 'Galileosky' },
        { type: 4, title: 'Wialon' },
    ],
    transportDeviceTypes: {
        1: 'galileosky',
        2: 'wialon',
        3: 'streamax',
        4: 'onlyWialon',
    },
    transportGroupCheckListFormMenu: [
        { value: 'text', originalValue: 'text', title: 'Текстовое поле' },
        { value: 'photo', originalValue: 'photo', title: 'Фотография' },
        { value: 'textarea', originalValue: 'textarea', title: 'Описание' },
        { value: 'number', originalValue: 'number', title: 'Число' },
        { value: 'date', originalValue: 'date', title: 'Дата' },
        { value: 'hose_check_date', originalValue: 'date', title: 'Акт проверки электропроводимости шлангов' },
        { value: 'dk_tractor_date', originalValue: 'date', title: 'Диагностическая карта на тягач' },
        { value: 'sr_un1203_date', originalValue: 'date', title: 'Спецразрешение UN1203 (дата окончания)' },
        { value: 'osago_date', originalValue: 'date', title: 'Полис ОСАГО (дата окончания)' },
        { value: 'dopog_tractor_date', originalValue: 'date', title: 'Свидетельство ДОПОГ на тягач (дата окончания)' },
        { value: 'tacho_calib_date', originalValue: 'date', title: 'Акт калибровки тахографа' },
        { value: 'fe_op2_date', originalValue: 'date', title: 'Огнетушитель ОП-2 (дата проверки/заряда)' },
        { value: 'dk_ppc_date', originalValue: 'date', title: 'Диагностическая карта на полуприцеп-цистерну' },
        { value: 'svid_poverka_date', originalValue: 'date', title: 'Свидетельство о поверке цистерны' },
        { value: 'dopog_ppc_date', originalValue: 'date', title: 'Свидетельство ДОПОГ на полуприцеп-цистерну' },
        { value: 'fe_6kg_date', originalValue: 'date', title: 'Огнетушители 6 кг (дата проверки/заряда)' },
        { value: 'first_aid_kit_date', originalValue: 'date', title: 'Аптечка (дата окончания срока комплектации)' },
        { value: 'eye_wash_date', originalValue: 'date', title: 'Жидкость для промывки глаз (срок годности)' },
        { value: 'instructions_date', originalValue: 'date', title: 'Письменные инструкции (дата актуализации)' },
        { value: 'select', originalValue: 'select', title: 'Поле выбора' },
        { value: 'boolean', originalValue: 'boolean', title: 'Чекбокс' },
        { value: 'vehicle_mileage', originalValue: 'number', title: 'Пробег ТС' },
        { value: 'vehicle_license_plate', originalValue: 'text', title: 'Госномер ТС' },
        { value: 'trailer_license_plate', originalValue: 'text', title: 'Госномер ППЦ' },
    ],
    // Типы полей шаблонов чеклистов для Voykan (без документов/данных ТС)
    checklistTemplateFormMenuVoykan: [
        { value: 'text', originalValue: 'text', title: 'Текстовое поле' },
        { value: 'photo', originalValue: 'photo', title: 'Фотография' },
        { value: 'textarea', originalValue: 'textarea', title: 'Описание' },
        { value: 'number', originalValue: 'number', title: 'Число' },
        { value: 'date', originalValue: 'date', title: 'Дата' },
        { value: 'select', originalValue: 'select', title: 'Поле выбора' },
        { value: 'boolean', originalValue: 'boolean', title: 'Чекбокс' },
    ],
    inspectionModeOptions: [
        { value: '', title: 'По умолчанию (подробный)' },
        { value: 'defects_first', title: 'Акцент на важном (быстрый)' },
        { value: 'voykan', title: 'Voykan (блоки, без перехода дальше)' },
    ],
    inspectionModeOptionsVoykan: [
        { value: 'voykan', title: 'Voykan (последовательный, каждый блок до конца)' },
        { value: '', title: 'Подробный (каждый блок до конца)' },
        { value: 'defects_first', title: 'Быстрый (акцент на дефектах)' },
    ],
    inspectionModeHelper: 'По умолчанию — подробный сценарий как сейчас; «Акцент на важном (быстрый)» — отдельный режим мобильного приложения.',
    inspectionModeHelperVoykan: 'Задаёт режим заполнения шаблона осмотра в мобильном приложении',
    checkpointRequiredLabel: 'Влияет на выезд',
    checkpointRequiredHelper: 'Определяет допуск транспортного средства к выезду',
    checkpointRequiredLabelVoykan: 'Блокирует допуск',
    checkpointRequiredHelperVoykan: 'При отрицательном результате бригада не допускается к работам',
    transportGroupPresetColors: ['#43b2ed', '#3caf54', '#fdfd34'],
    transportListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
        itemStickyHeight: 30,
    },
    transportGroupListOptions: {
        itemHeight: 36,
        itemBuffered: 30,
    },
    trailerColumns: [
        { name: 'number', label: 'Госномер', width: 124, order: 'ASC' },
        { name: 'vin', label: 'VIN номер', width: 184, order: 'ASC' },
        { name: 'fuel_level_sensor', label: 'Датчик уровня топлива', width: 190, order: 'ASC' },
    ],
    trailerListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
        itemStickyHeight: 30,
    },
    geofenceGroupListOptions: {
        itemHeight: 36,
        itemBuffered: 30,
    },
    reportGeofenceListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
    },
    mapFilterTabs: [
        { name: 'transport', label: 'Транспорт' },
        { name: 'geofence', label: 'Геозоны' },
        { name: 'task', label: 'Задания' },
    ],
    mapTransportTabs: [
        { name: 'info', label: 'Информация', disabled: false },
        { name: 'broadcast', label: 'Видео', disabled: false },
        { name: 'flight', label: 'Рейсы', disabled: false },
        { name: 'chart', label: 'Графики', disabled: false },
        { name: 'condition', label: 'Состояния', disabled: false },
        { name: 'event', label: 'Журнал событий', disabled: false },
    ],
    mapConditionListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
        offsetHeight: 559,
    },
    mapEventListOptions: {
        itemHeight: 50,
        itemPadding: 16,
        itemBuffered: 10,
        itemLetters: 60,
        offsetHeight: 589,
    },
    mapGeofenceListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
    },
    mapTaskListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
        itemStickyHeight: 30,
    },
    mapTransportListOptions: {
        itemHeight: 24,
        itemBuffered: 30,
        itemStickyHeight: 30,
    },
    mapTransportCommandMessages: {
        200: 'Команда отправлена «$name»',
        429: 'Превышен лимит при отправке команды «$name»',
        500: 'Произошла ошибка при отправке команды «$name»',
    },
    mapTransportEventMessages: {
        1: '$name на $geofence $datetime',
    },
    mapTransportConditionAnalysisFilters: [],
    mapTransportConditionFilters: [
        { name: 'guard', label: 'Охрана', filters: [], deviceTypes: ['galileosky'] },
        { name: 'alert', label: 'Тревоги', filters: [], deviceTypes: ['galileosky'] },
        { name: 'reason', label: 'Причины', filters: [], deviceTypes: ['galileosky'] },
        { name: 'speed', label: 'Движение', filters: [], deviceTypes: ['galileosky'] },
        { name: 'engine', label: 'Двигатель', filters: [], deviceTypes: ['galileosky'] },
        { name: 'geofence', label: 'Геозоны', filters: [], deviceTypes: ['galileosky', 'onlyWialon'] },
        { name: 'command', label: 'Команды', filters: [], deviceTypes: ['galileosky'] },
        { name: 'other', label: 'Прочие', filters: [], deviceTypes: ['galileosky', 'onlyWialon'] },
    ],
    mapTransportFilters: [
        { name: 'guard', label: 'Охрана', checked: false, permissions: ['read'] },
        { name: 'alarm', label: 'Тревога', checked: false, permissions: ['read'] },
        { name: 'drain', label: 'Слив', checked: false, permissions: ['read'] },
        { name: 'pouring', label: 'Налив', checked: false, permissions: ['read'] },
        { name: 'parking', label: 'Парковка', checked: false, permissions: ['read'] },
        { name: 'speed', label: 'Движение', checked: false, permissions: ['read'] },
        { name: 'signal', label: 'Потеря связи', checked: false, permissions: ['read'] },
        { name: 'parking_time', label: 'Стоянка от 10 минут', checked: false, permissions: ['read'] },
        { name: 'activity', label: 'Потеря связи 2216', hidden: true, permissions: ['activity'] },
    ],
    mapTaskFilters: [
        { name: 'active', label: 'Активные' },
        { name: 'finished', label: 'Завершенные' },
    ],
    mapTransportColumns: [
        { name: 'check', label: '', minWidth: 53, width: 53, maxWidth: 58, hidden: false, permissions: ['read', 'activity'] },
        { name: 'name', label: 'Название', minWidth: 87, width: 90, maxWidth: 150, order: 'ASC', hidden: false, permissions: ['read', 'activity'] },
        { name: 'number', label: 'Госномер', minWidth: 80, width: 100, maxWidth: 120, order: 'ASC', hidden: true, permissions: ['read', 'activity'] },
        { name: 'condition', label: 'Состояния', minWidth: 90, width: 128, maxWidth: 170, order: 'ASC', hidden: false, permissions: ['read', 'activity'] },
        { name: 'geofence', label: 'Геозона', minWidth: 80, width: 106, maxWidth: 200, order: 'ASC', hidden: false, permissions: ['read'] },
        { name: 'total_mileage_avg', label: 'Пробег', minWidth: 73, width: 73, maxWidth: 100, order: 'ASC', hidden: false, permissions: ['read'] },
        { name: 'parking_time', label: 'Парковка', icon: 'TransportParkingIcon', minWidth: 50, width: 50, maxWidth: 100, order: 'ASC', hidden: false, permissions: ['read'] },
        { name: 'sensor_count', label: 'Датчики', icon: 'TransportSensorIcon', minWidth: 46, width: 46, maxWidth: 80, order: 'ASC', hidden: false, permissions: ['read'] },
        { name: 'signal_off', label: 'Потеря связи', icon: 'TransportConditionSignalOffIcon', minWidth: 42, width: 42, maxWidth: 80, order: 'ASC', hidden: true, permissions: ['read'] },
        { name: 'guard_status_sum', label: 'Топливо', icon: 'TransportFuelIcon', minWidth: 48, width: 48, maxWidth: 80, order: 'ASC', hidden: false, permissions: ['read'] },
        { name: 'last_activity_date', label: 'Потеря связи', minWidth: 100, width: 111, maxWidth: 150, order: 'ASC', hidden: true, permissions: ['activity'] },
    ],
    mapTaskColumns: [
        { name: 'id', label: '№', width: 60, order: 'ASC' },
        { name: 'status', label: 'Статус', width: 90, order: 'ASC' },
        { name: 'transport_number', label: 'Название', width: 180, order: 'ASC' },
        { name: 'task_date', label: 'Дата начала', width: 130, order: 'DESC' },
        { name: 'finished_date', label: 'Дата завершения', width: 140, order: 'ASC' },
    ],
    mapTransportTaskColumns: [
        { name: 'section', label: '№', width: 34, order: 'ASC', hidden: false },
        { name: 'gs_num', label: 'АЗС', width: 200, order: 'ASC', hidden: false },
        { name: 'product', label: 'Продукт', width: 180, order: 'ASC', hidden: false },
        { name: 'volume', label: 'V, л', width: 40, hidden: false },
        { name: 'dut', label: 'ДУТ', width: 46, hidden: false },
    ],
    mapTransportViewOptions: {
        offsetX: -400,
        offsetY: 200,
    },
    mapDrawOptions: {
        templineStyle: {
            color: '#d32f2f',
        },
        hintlineStyle: {
            color: '#d32f2f',
            dashArray: [5, 5],
        },
        pathOptions: {
            color: '#d32f2f',
            fillColor: '#d32f2f',
        },
    },
    mapMultiColorsPolylineOptions: {
        colors: [{ color: '#cdc50a' }, { color: '#008000' }, { color: '#FF0000' }],
    },
    mapGeofenceOptions: {
        defaultRadius: 100,
        polygonEdges: 5,
        circleEdges: 64,
    },
    mapPopupOptions: {
        maxWidth: 300,
        minWidth: 300,
        closeButton: false,
    },
    mapPopupTransportOptions: {
        maxWidth: 700,
        minWidth: 700,
        closeButton: false,
    },
    mapMaxZoom: 18,
    mapMinTransportTooltipZoom: 8,
    mapMinGeofenceTooltipZoom: 11,
    mapMinGeofenceMarkerZoom: 13,
    mapBroadcastTimeout: 3000,
    mapBroadcastEventsDescription: {
        1: 'Сигнал потери видео',
        2: 'Датчик движения',
        3: 'Сигнал закрывающий камеру',
        4: 'Ошибка хранилища',
        5: 'IO1',
        6: 'IO2',
        7: 'IO3',
        8: 'IO4',
        9: 'IO5',
        10: 'IO6',
        11: 'IO7',
        12: 'IO8',
        13: 'Аварийный сигнал',
        14: 'Сигнал низкой скорости',
        15: 'Сигнал высокой скорости',
        16: 'Низкое напряжение',
        17: 'Сигнал ускорения',
        18: 'Геозона',
        19: 'Аномалия запуска',
        20: 'Недейтвительное отключение',
        29: 'Датчик температуры',
        36: 'Сигнал о столкновении',
        38: 'Покидание полосы',
        47: 'Аномальное изменение температуры',
        58: 'Вождение в усталом состоянии',
        59: 'Отсутствие водителя',
        60: 'Вызов водителя',
        61: 'Водитель курит',
        62: 'Отвлечение водителя',
        63: 'DSM Покидание полосы',
        64: 'DSM Сигнал о столкновении',
        74: 'Аномальное отключение панели',
        81: 'Датчик холостого хода дверной сигнализации',
        160: 'Сигнализация превышения скорости',
        161: 'Распознавание номерных знаков',
        162: 'Расстояние слишком близко',
    },
    passwordLength: 8,
    mapBroadcastChannels: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    mapBroadcastUrl: 'https://reg.lukoil-iface.a6u.ru',
    // Порты для превью-потоков: 12060-12063 рабочие, 12071-12075 не рабочие (требуют аналитики в будущем)
    mapBroadcastPorts: [60, 61, 62, 63, 71, 72, 73, 74, 75, 75],
    mapTransportTrackInterval: [1, 2, 4, 6, 8, 10, 12, 16, 20, 24],
    snackbarLimit: 100,
    snackbarTimeout: 12000,
    dunLimit: 30,
    dunCoverLimit: 30,
    speedLimit: 84,
    maxHistoryTransports: 20,
    voltageLimit: 20,
    activityTimeout: [
        { color: 'success', interval: [0, 600000] },
        { color: 'warning', interval: [600000, 10800000] },
        { color: 'error', interval: [10800000, Number.MAX_VALUE] },
    ],
    signalOffTimeout: [
        { color: 'error', interval: [0, 180000] },
        { color: 'success', interval: [180000, 600000] },
        { color: 'warning', interval: [600000, 10800000] },
        { color: 'error', interval: [10800000, Number.MAX_VALUE] },
    ],
    numberOfSignalStrength: [0, 1, 2, 3],
    drainSideOptions: [
        { value: 'none', label: 'Н/Д' },
        { value: 'left', label: 'Левая' },
        { value: 'right', label: 'Правая' },
        { value: 'both', label: 'Обе' },
    ],
    numberOfTank: [1, 2, 3, 4, 5, 6],
    retransmissionLukoilPrefix: ['YNP', 'LCNP', 'SZNP', 'UNP'],
    retransmissionProtocol: [
        { value: 1, name: 'Протокол Wialon' },
        { value: 2, name: 'Протокол EGTS' },
    ],
    mapCenter: [55.753559, 37.609218],
    mapLayer: ['Google', 'GoogleHybrid', 'Yandex', 'YandexHybrid', 'OpenStreet', 'OpenStreetSatellite'],
    mapLayerDefault: 'Yandex',
    scrollThreshold: 400,
    mailto: 'mailto:wpt-support@digitalsol.tech',
    userRoles: {
        ADMIN: 2,
        OPERATOR: 3,
        OBSERVER: 4,
        MECHANIC: 5,
        CUSTOMER: 6,
        ENGINEER: 7,
        SUPERADMIN: 8,
        INSPECTOR_CHECKLIST: 9,
        ADMIN_CHECKLIST: 10,
        OPERATOR_CHECKLIST: 11,
        INSPECTOR_OPERATOR_CHECKLIST: 12,
    },
    messageHdopLimit: 1,
    timezoneOffsets: [
        { region: 'Kaliningrad Oblast', title: '+02:00', value: 120 },
        { region: 'Most of European Russia (Moscow and surrounding areas)', title: '+03:00', value: 180 },
        { region: 'Samara Oblast, Astrakhan Oblast, Ulyanovsk Oblast, Udmurt Republic', title: '+04:00', value: 240 },
        { region: 'Sverdlovsk Oblast, Tyumen Oblast, Kurgan Oblast, Bashkortostan, Chelyabinsk Oblast, Orenburg Oblast, Perm Krai, Khanty-Mansi Autonomous Okrug, Yamalo-Nenets Autonomous Okrug', title: '+05:00', value: 300 },
        { region: 'Omsk Oblast', title: '+06:00', value: 360 },
        { region: 'Krasnoyarsk Krai, Novosibirsk Oblast, Kemerovo Oblast, Altai Krai, Altai Republic, Tomsk Oblast, Khakassia, Tuva', title: '+07:00', value: 420 },
        { region: 'Irkutsk Oblast, Buryatia', title: '+08:00', value: 480 },
        { region: 'Zabaykalsky Krai, Amur Oblast, most of Sakha Republic', title: '+09:00', value: 540 },
        { region: 'Jewish Autonomous Oblast, Khabarovsk Krai, Primorsky Krai, parts of Sakha Republic', title: '+10:00', value: 600 },
        { region: 'Magadan Oblast, Sakhalin Oblast, parts of Sakha Republic', title: '+11:00', value: 660 },
        { region: 'Kamchatka Krai, Chukotka Autonomous Okrug', title: '+12:00', value: 720 },
    ],
};

Object.values(config.compareEvents).forEach(function (events) {
    events.forEach(function (event) {
        if (event.analysis) {
            config.mapTransportConditionAnalysisFilters.push(event.key);
        }

        config.mapTransportConditionFilters.forEach(function (filter, key) {
            if (filter.name === event.name) {
                config.mapTransportConditionFilters[key].filters.push(event.key);
            }
        });
    });
});

export default config;
